module.exports = __webpack_public_path__ + "static/media/SegoeBold.65099f98.ttf";